import React, { useCallback, useMemo } from 'react';
import { ConfigureWorkflowBaseProps } from 'apps/sigma2-ui/src/components/workflows/types';
import { WriteBackToGreenhousePlaceToWrite } from 'libs/end-to-end/src/types/databases/workflows/strategies/greenhouse-write-back';
import { WriteBackToGreenhouseStrategy } from 'libs/end-to-end/src/types/databases/workflows/strategies/greenhouse-write-back';
import { WriteBackToGreenhouseAuthMethod } from 'libs/end-to-end/src/types/databases/workflows/strategies/greenhouse-write-back';
import { ConfigureWriteBackGreenhouseAuthMethod } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackGreenhouseAuthMethod';
import { ConfigureWriteBackGreenhousePlacesToWrite } from 'apps/sigma2-ui/src/components/workflows/ConfigureWriteBackGreenhousePlacesToWrite';

export interface ConfigureWriteBackGreenhouseStrategyProps
  extends ConfigureWorkflowBaseProps {
  strategy: WriteBackToGreenhouseStrategy;

  updateStrategy: (strategy: WriteBackToGreenhouseStrategy) => void;
}

export const ConfigureWriteBackGreenhouseStrategy = ({
  strategy,
  updateStrategy,
  listSecretsPattern,
  organizationId,
  listDataSetsPattern,
}: ConfigureWriteBackGreenhouseStrategyProps) => {
  const updateAuthMethod = useCallback(
    (authMethod: WriteBackToGreenhouseAuthMethod | null) => {
      updateStrategy({
        ...strategy,
        authMethod: authMethod ?? undefined,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedAuthMethod = useMemo(
    () => strategy?.authMethod ?? null,
    [strategy?.authMethod],
  );

  const updatePlacesToWrite = useCallback(
    (placesToWrite: WriteBackToGreenhousePlaceToWrite[]) => {
      updateStrategy({
        ...strategy,
        placesToWrite,
      });
    },
    [strategy, updateStrategy],
  );

  const selectedPlacesToWrite = useMemo(
    () => strategy?.placesToWrite ?? [],
    [strategy?.placesToWrite],
  );

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <h2 className="text-xl font-semibold">Configure Greenhouse Strategy</h2>
      <p className="text-gray-600">
        Configure the strategy for writing back the hiring readiness score to
        Greenhouse.
      </p>

      <ConfigureWriteBackGreenhouseAuthMethod
        authMethod={selectedAuthMethod}
        updateAuthMethod={updateAuthMethod}
        listSecretsPattern={listSecretsPattern}
        organizationId={organizationId}
        listDataSetsPattern={listDataSetsPattern}
      />

      <ConfigureWriteBackGreenhousePlacesToWrite
        placesToWrite={selectedPlacesToWrite}
        updatePlacesToWrite={updatePlacesToWrite}
        listSecretsPattern={listSecretsPattern}
        organizationId={organizationId}
        listDataSetsPattern={listDataSetsPattern}
      />
    </div>
  );
};
